import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IResetPasswordParams {
  resetToken: string;
  newEncryptedPassword: string;
  encryptionKeyId: string;
}

export class ResetPasswordRequest extends Request<IResetPasswordParams, IResult> {
  constructor(params: IResetPasswordParams) {
    super('resetPassword', params);
  }
}
